import { fork } from 'redux-saga/effects';

import { watcher as appointmentPayaAccountFormPaymentReqWatcher } from './requests/appointment-account-form-payment-req';

export default function* appointmentsRootSaga() {
  yield fork(appointmentPayaAccountFormPaymentReqWatcher);
}



// WEBPACK FOOTER //
// ./src/redux/appointmnents/root-saga.js